










import { Component, Vue } from 'vue-property-decorator'
import { UserAPI } from '@/api/backend-client'

@Component
export default class Documents extends Vue {
    get src() {
        const urlParams = new URLSearchParams({
            token: UserAPI.refreshToken,
            redirect: `${process.env.VUE_APP_ONE_APP_BASEURL}/document/template`,
        })

        return `${process.env.VUE_APP_ONE_APP_BASEURL}/authenticate?` + urlParams.toString()
    }
}
